import { render, staticRenderFns } from "./ButtonProp.vue?vue&type=template&id=48301e80&"
import script from "./ButtonProp.vue?vue&type=script&lang=js&"
export * from "./ButtonProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports